import PropTypes from "prop-types";

import EyeIcon from "@/icons/EyeIcon";
import EyeSlashIcon from "@/icons/EyeSlashIcon";
import ActionPopOutOption from "@/view/ActionPopOutOption";
import {
  classroomWrapperCss,
  elementaryLabelCss,
  disabledCss,
} from "../HideOptions.style";

const propTypes = {
  classroomId: PropTypes.number,
  currentLevelId: PropTypes.string,
  disabled: PropTypes.bool,
  grade: PropTypes.number,
  handleHideContent: PropTypes.func,
  handleUnhideContent: PropTypes.func,
  hideId: PropTypes.number,
  isContentHidden: PropTypes.bool,
  name: PropTypes.string,
  dataProps: PropTypes.object,
};

const HideOption = ({
  classroomId,
  currentLevelId,
  disabled,
  grade,
  handleHideContent,
  handleUnhideContent,
  hideId,
  isContentHidden,
  name,
  dataProps,
}) => {
  const IconComponent = isContentHidden ? <EyeSlashIcon /> : <EyeIcon />;
  const clickFunc = isContentHidden ? handleUnhideContent : handleHideContent;
  const hideParameters = isContentHidden
    ? { hideId, name }
    : { classroomId, name };
  const sharedEventProperties = {
    actionName: "Hide",
    objectType: "Content",
    streamProperties: {
      content_id: currentLevelId,
      content_type: "Article",
      description: `${isContentHidden ? "Unhide" : "Hide"} content`,
    },
  };
  const eventProperties = isContentHidden
    ? { ...sharedEventProperties, actionPrefix: "Undo" }
    : sharedEventProperties;

  const title = (
    <span style={classroomWrapperCss}>
      {name}
      {grade < 6 && (
        <span css={elementaryLabelCss} aria-label="Elementary">
          ELEM
        </span>
      )}
    </span>
  );

  const ariaProps = {
    "aria-label": `${isContentHidden ? "Open" : "Hide"} ${name}`,
  };

  return (
    <ActionPopOutOption
      ariaProps={ariaProps}
      disabled={disabled}
      disabledCss={disabledCss}
      eventProperties={eventProperties}
      icon={IconComponent}
      onClick={() => clickFunc(hideParameters)}
      title={title}
      dataProps={dataProps}
    />
  );
};

HideOption.propTypes = propTypes;

export default HideOption;
